import cx from "classnames";

import { Card, CardProps } from "ui/Card";
import { StrapiImage, StrapiImageData } from "ui/StrapiImage";

type PictureCardPropsExtra = { image: StrapiImageData; loader?: boolean };

type PictureCardProps = PictureCardPropsExtra & CardProps;

export const PictureCard = ({
  image,
  className,
  loader,
  ...props
}: PictureCardProps) => (
  <Card className={cx("p-4 w-24 h-24", className)} {...props}>
    <StrapiImage
      size="small"
      image={image}
      className="w-16 h-16"
      loader={loader}
      sizes="10vw"
    />
  </Card>
);
